import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { createUser, updateUser } from "services/UserService";

const UserForm = () => {
  const [formData, setFormData] = useState({
    emp_code: "",
    first_name: "",
    phone: "",
    email: "",
    password: "",
    hint: "",
    permissions: [],
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);  
  const navigate = useNavigate();
  const location = useLocation();
  const { isEdit, editFormData } = location.state || { isEdit: false, editFormData: {} };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCheckbox = (e) => {    
    const { value, checked } = e.target;
    console.log(formData)
    const updatedPermissions = checked
      ? [...formData.permissions, value]
      : formData.permissions.filter((perm) => perm !== value);
    setFormData({ ...formData, permissions: updatedPermissions });
  };

  useEffect(() => {
    if (isEdit && editFormData) {
      const { password, permissions, ...rest } = editFormData;
      let parsedPermissions = [];
      parsedPermissions = permissions ? JSON.parse(permissions) : [];     
      setFormData({ ...rest, password: "", permissions: parsedPermissions});
      
    }
  }, [isEdit, editFormData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const newErrors = validate();
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
      } else {
        setErrors({});
        setLoading(true);
        const payload = {
          ...formData,
          permissions: JSON.stringify(formData.permissions),
        };
        let response;
        if(isEdit)
        {
           response = await updateUser(payload);
        }else{
           response = await createUser(payload);
        }
        
        setLoading(false);
        if (response?.data?.success) {
          navigate("/users");
        } else if (response?.data?.errors) {
        
          const serverErrors = {};
          for (const field in response.data.errors) {
            serverErrors[field] = response.data.errors[field][0]; 
          }
          setErrors(serverErrors);
        }
      }
    } catch (error) {
      console.error("Error adding user:", error);
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.first_name) {
      newErrors.first_name = "Name is required";
    }
    if (!formData.email) {
      newErrors.email = "Email is required";
    }
    if (!formData.password) {
      newErrors.password = "Password is required";
    }
    return newErrors;
  };

  return (
    <>
      <section className="content-header">
        <div className="header-icon">
          <i className="fa fa-users"></i>
        </div>
        <div className="header-title">
          <h1>Delight STAY</h1>
          <small>Hotel Manage admin Panel.</small>
        </div>
      </section>

      <section className="content">
        <div className="row">
          <div className="col-sm-12">
            <div className="card lobicard all_btn_card">
              <div className="card-header all_card_btn">
                <div className="card-title custom_title">
                  <Link className="btn btn-add" to="/users">
                    <i className="fa fa-list"></i> Users List
                  </Link>
                </div>
              </div>
              <div className="card-body">
                <form className="col-sm-12" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label>Employee Code</label>
                    <input
                      type="text"
                      className="form-control"
                      name="emp_code"
                      placeholder="Enter Employee Code"
                      value={formData.emp_code}
                      onChange={handleChange}
                      required
                    />
                     {errors.emp_code && (
                      <small className="text-danger">{errors.emp_code}</small>
                    )}
                  </div>

                  <div className="form-group">
                    <label>Employee Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="first_name"
                      placeholder="Enter Employee Name"
                      value={formData.first_name}
                      onChange={handleChange}
                      required
                    />
                    {errors.first_name && (
                      <small className="text-danger">{errors.first_name}</small>
                    )}
                    
                  </div>

                  <div className="form-group">
                    <label>Employee Phone No.</label>
                    <input
                      type="number"
                      className="form-control"
                      name="phone"
                      placeholder="Enter Employee Phone No."
                      value={formData.phone}
                      onChange={handleChange}
                      required
                    />
                     {errors.phone && (
                      <small className="text-danger">{errors.phone}</small>
                    )}
                    
                  </div>

                  <div className="form-group">
                    <label>Login User Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="email"
                      placeholder="Enter Login User Name"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                    {errors.email && (
                      <small className="text-danger">{errors.email}</small>
                    )}
                  </div>

                  <div className="form-group">
                    <label>Login Password</label>
                    <input
                      type="password"
                      className="form-control"
                      name="password"
                      placeholder="Enter Login Password"
                      value={formData.password}
                      onChange={handleChange}
                      
                    />
                    {errors.password && (
                      <small className="text-danger">{errors.password}</small>
                    )}
                  </div>

                  <div className="form-group">
                    <label>Enter Hint</label>
                    <input
                      type="password"
                      className="form-control"
                      name="hint"
                      placeholder="Enter hint"
                      value={formData.hint}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label className="label-permissions">Permissions</label>
                    {[
                      {
                        title: "Manage Users",
                        permissions: [
                          "Add Users",
                          "View Users",
                          "Edit Users",
                          "Delete Users",
                        ],
                      },
                      {
                        title: "Manage Hotels",
                        permissions: [
                          "Add Hotel",
                          "View Hotel",
                          "Delete Hotel",
                          "Edit Hotel",
                        ],
                      },
                      {
                        title: "Manage Agent",
                        permissions: [
                          "Add Agent",
                          "View Agent",
                          "Delete Agent",
                          "Edit Agent",
                        ],
                      },
                      {
                        title: "Manage Booking",
                        permissions: [
                          "Add Booking",
                          "Add Booking Payment",
                          "View Booking",
                          "Delete Booking",
                          "Edit Booking",
                        ],
                      },
                      {
                        title: "Manage Billing",
                        permissions: [
                          "Add Billing",
                          "View Billing",
                          "Delete Billing",
                          "Edit Billing",
                        ],
                      },
                      {
                        title: "Manage Room Category",
                        permissions: [
                          "Add Room Category",
                          "View Room Category",
                          "Delete Room Category",
                          "Edit Room Category",
                        ],
                      },
                      {
                        title: "Manage City",
                        permissions: [
                          "Add City",
                          "View City",
                          "Delete City",
                          "Edit City",
                        ],
                      },
                      {
                        title: "Manage Room Type",
                        permissions: [
                          "Add Room Type",
                          "View Room Type",
                          "Delete Room Type",
                          "Edit Room Type",
                        ],
                      },
                    ].map((section, i) => (
                      <div key={i} className="checkoboxes mb-2">
                        <h6 className="mb-1">{section.title}</h6>
                        {section.permissions.map((perm, j) => (
                          <div key={j} className="form-check form-check-inline">
                            <input
                              className="form-check-input position-static"
                              type="checkbox"
                              id={`${section.title}-${perm}`}
                              value={perm}
                              checked={formData.permissions.includes(perm)}
                              onChange={handleCheckbox}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`${section.title}-${perm}`}
                            >
                              {perm}
                            </label>
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>

                  <div className="reset-button">
                    <button type="submit" className="btn btn-success" disabled={loading}>
                      {loading ? "Saving..." : "Save"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default UserForm;
